<template>
    <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Standort editieren</h3>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="editLocation($route.params.id)">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Angaben zum Standort</h6>
                    <locationform ref="LForm"/>
                    <!-- Address -->
                    <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Standortdaten ändern</span></button>
                </form>
            </template>
        </card>
</template>

<script>
    import Locationform from "@/views/Locations/Locationform";
    export default {
        name: "edit",
        components: {Locationform},
        data() {
            return {
                isLoading: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            this.showLocation(this.$route.params.id)
        },
        computed: {

        },
        methods: {
            locationdata () {
                return this.$refs.LForm.location;
            },
            showLocation(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/locations/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$refs.LForm.location = response;
                                if (typeof response.state !== 'undefined') this.$refs.LForm.location.state = response.state['@id'];
                                if (typeof response.customer !== 'undefined') this.$refs.LForm.location.customer = response.customer['@id'];
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            editLocation(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = this.$refs.LForm.location;
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/locations/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Standort '+response.name+' (ID: '+response.id+') wurde editiert.'};
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        }
    }
</script>

<style scoped>

</style>